import { AfterContentChecked, Directive } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { IAccordionDirective } from './iAccordionDirective';
import { IAccordionItemDirective } from './iAccordionItemDirective';

@Directive({
  selector: '[navAccordion]',
})
export class AccordionDirective implements IAccordionDirective, AfterContentChecked {
  protected navlinks: Array<IAccordionItemDirective> = [];

  constructor(private router: Router) {
    /*
     * Fix: `ERROR Error: ExpressionChangedAfterItHasBeenCheckedError:
     * Expression has changed after it was checked`.
     */
    setTimeout(() => this.checkOpenLinks());
  }

  addLink(link: IAccordionItemDirective): void {
    this.navlinks.push(link);
  }

  checkOpenLinks() {
    for (const link of this.navlinks) {
      if (link.group) {
        const routeUrl = this.router.url;
        const currentUrl = routeUrl.split('/');
        if (currentUrl.includes(link.group)) {
          link.open = true;
          this.closeOtherLinks(link);
        }
      }
    }
  }

  closeOtherLinks(openLink: IAccordionItemDirective): void {
    for (const link of this.navlinks) {
      if (link !== openLink) {
        link.open = false;
      }
    }
  }

  ngAfterContentChecked(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => this.checkOpenLinks());
  }

  removeGroup(link: IAccordionItemDirective): void {
    const index = this.navlinks.indexOf(link);
    if (index !== -1) {
      this.navlinks.splice(index, 1);
    }
  }
}
